import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassPointerSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"compass-pointer-square, gps, direction"} maskId="square-filled-radius-0-stroke-1-IconCompassPointerSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.27246 16.7266L12 15.0869L16.7275 16.7266L12 6.99805L7.27246 16.7266Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCompassPointerSquare;
